/* eslint-disable */
import React, { useContext, useEffect, useMemo, useState } from "react";

import { useHistory, Link } from "react-router-dom";
import {
  Grid,
  Paper,
  TextField,
  Button,
  Typography,
} from "@material-ui/core";

// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import { AuthContext } from "../../contexts/authContext";

import { useValidEmail } from "../../hooks/useValidEmail";
import {
  alertStyle,
  backgroundStyle,
  btnStyle,
  h3Style,
  inputStyle,
  logoStyle,
  paperStyle,
  pStyle,
  TypographyStyle,
} from "./styles";
import { IUserAuth } from "interfaces/IUserAuth";
import { useValidPasswordAdvance } from "hooks/useValidPasswordAdvance";
import { useValidCode } from "hooks/useValidCode";
import { Alert } from "@mui/material";
import { Header } from "components/Header/Header";

const SignUp: React.FunctionComponent = () => {
  /* States and context declaration */
  const { email, setEmail } = useValidEmail(null);
  const [phone, setPhone] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const { passwordAdvance, setPasswordAdvance, passwordAdvanceIsValid } =
    useValidPasswordAdvance(null);
  const [confirmPass, setConfirmPass] = useState("");
  const [confirmPassError, setConfirmPassError] = useState("");
  const { code, codeIsValid } = useValidCode(null);

  /* Generic Error Message */
  const [genericErrorMessage, setGenericErrorMessage] = useState("");

  /* Callback and Memo, Optimization Section */
  const theme = useMemo(() => {
    return authContext.globalConfig?.theme as unknown as undefined;
  }, [authContext]);

  /* 
   Functions Section 
   */
  useEffect(() => {
    onComparePassword(confirmPass);
  }, [confirmPass, passwordAdvance]);

  const onComparePassword = (confirmPass: string) => {
    //setConfirmPass(confirmPass);
    if (confirmPass === "") {
      setConfirmPassError("");
      return;
    }
    if (confirmPass !== passwordAdvance) {
      setConfirmPassError(
        "The passwords you have entered don’t match, please correct to proceed"
      );
    } else {
      setConfirmPassError("Passwords match");
    }
  };

  const onRegister = async (e: any) => {
    e.stopPropagation();
    if (firstName && lastName && email && phone && passwordAdvance)
      try {
        const userAuth: IUserAuth = {
          username: email.toLowerCase(),
          password: passwordAdvance,
          phone_number: ("+" + phone) as unknown as string,
          email: email.toLowerCase(),
          firstName: firstName as unknown as string,
          lastName: lastName as unknown as string,
        };
        await authContext.signUpWithPhone(userAuth);
        history.push(`/VerifyEmail/${firstName}/${lastName}/${email}/${phone}`);
      } catch (error: any) {
        // toast.error(error.message, {
        //   position: toast.POSITION.TOP_CENTER
        // });
        setGenericErrorMessage(error.message);
      }
  };

  const onchangePassword = async () => {
    if (!email && !passwordAdvance && codeIsValid) {
      setConfirmPass("");
      setPasswordAdvance("");
      return;
    }
    try {
      await authContext.forgotPassword(email?.toLowerCase(), code, passwordAdvance);
      history.push("/SignIn");
    } catch (error: any) {
      console.log(error.message);
      setGenericErrorMessage(error.message);
    }
  };

  const onSignUpPressed = async (e: any) => {
    e.stopPropagation();
    if (firstName && lastName && email && phone)
      history.push(`/VerifyEmail/${firstName}/${lastName}/${email}/${phone}`, {
        state: {
          firstName,
          lastName,
          email,
          phone,
        },
      });
  };

  const signUpGroups = {
    margin: "0 0 12px",
  };

  return (
    <>
    <Header showSettings={false}/>
    <div style={backgroundStyle}>
      <Grid>
      {/* <ToastContainer /> */}
        <Paper
          elevation={1}
          style={{ ...paperStyle, height: "853px", margin: "20px auto" }}
        >
          <Grid style={{ ...logoStyle, margin: "37px auto", width: "315px" }}>
            <h3 style={h3Style}>Register</h3>
            <p style={pStyle}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor.
            </p>
          </Grid>
          <div style={{ ...signUpGroups, textAlign: "center" }}>
            <TextField
              size="small"
              variant="outlined"
              placeholder="First Name"
              fullWidth
              required
              style={inputStyle}
              onChange={(e: any) => setFirstName(e.target.value)}
            />
            <TextField
              size="small"
              variant="outlined"
              placeholder="Last Name"
              fullWidth
              required
              style={inputStyle}
              onChange={(e: any) => setLastName(e.target.value)}
            />
          </div>
          <div style={{ ...signUpGroups, textAlign: "center" }}>
            <TextField
              size="small"
              variant="outlined"
              placeholder="Email"
              fullWidth
              required
              style={inputStyle}
              onChange={(e: any) => setEmail(e.target.value)}
            />
            <TextField
              size="small"
              variant="outlined"
              placeholder="Phone"
              fullWidth
              required
              style={inputStyle}
              onChange={(e: any) => setPhone(e.target.value)}
            />
          </div>
          <div style={{ ...signUpGroups, textAlign: "center" }}>
            {passwordAdvanceIsValid[0].text === "Password Strength: Good" &&
            confirmPassError === "Passwords match" ? null : (
              <Alert
                style={alertStyle}
                variant="outlined"
                severity="error"
              >
                Error: Password too week or didn't match.
              </Alert>
            )}
            {genericErrorMessage === "Invalid phone number format." ? (
              <Alert
                style={alertStyle}
                variant="outlined"
                severity="error"
              >
                Invald phone format: input your phone with country code without
                +.
              </Alert>
            ) : null}
            <TextField
              size="small"
              variant="outlined"
              placeholder="Password"
              type="password"
              fullWidth
              required
              style={inputStyle}
              error={
                passwordAdvanceIsValid[0].text === "Password Strength: Good" &&
                confirmPassError === "Passwords match"
                  ? false
                  : true
              }
              onChange={(e: any) => setPasswordAdvance(e.target.value)}
            />
            <TextField
              size="small"
              variant="outlined"
              placeholder="Confirm Password"
              type="password"
              fullWidth
              required
              style={inputStyle}
              error={
                passwordAdvanceIsValid[0].text === "Password Strength: Good" &&
                confirmPassError === "Passwords match"
                  ? false
                  : true
              }
              onChange={(e: any) => setConfirmPass(e.target.value)}
            />
          </div>
          <div style={{ margin: "0px auto", width: "315px" }}>
            <p style={pStyle}>
              Password must at least 8 characters long with at least one number
              and one special character (!@#$%&)
            </p>
            <p style={pStyle}>
              By pressing Register you agree to our Terms & Conditions and
              Privacy Policy.
            </p>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              style={btnStyle}
              fullWidth
              onClick={(e) => {
                onRegister(e);
              }}
              disabled={
                passwordAdvanceIsValid[0].text === "Password Strength: Good" &&
                confirmPassError === "Passwords match"
                  ? false
                  : true
              }
            >
              Create Account
            </Button>
            <Typography style={TypographyStyle}>
              {" "}
              Have an account? <Link to="/SignIn"> Login</Link>
            </Typography>
          </div>
        </Paper>
      </Grid>
    </div>
    </>
  );
};

export default SignUp;
